import locales from "../locales";

export const CURRENCY_HUF = 'HUF';
export const CURRENCY_EUR = 'EUR';

export function getCurrencyOptions(): Array<{ value: string, key: string, title: string, fraction: boolean }> {
  return [
    {value: CURRENCY_HUF, key: CURRENCY_HUF, title: locales.currency_huf, fraction: false},
    {value: CURRENCY_EUR, key: CURRENCY_EUR, title: locales.currency_eur, fraction: true},
  ];
}

export function calculateHufSum(sum: number | undefined, currency: string | undefined, exchangeRate: number | undefined): number | undefined {
  if (!sum) {
    return undefined;
  }
  if (!currency || currency === CURRENCY_HUF) {
    return sum;
  }
  if (!exchangeRate || exchangeRate <= 0) {
    return undefined;
  }
  return sum * exchangeRate;
}



// WEBPACK FOOTER //
// ./src/utils/currency-utils.ts